import { isEmpty, map } from 'lodash';
import turf from '@turf/turf';

import * as videoOps from '../../api/Videos/video-operations';

import * as templateOps from '../../api/AnnotationTemplates/annotation-template-operations';

import { featurePoint2KML, featureLinestring2KML } from '../geojson-utilities';

const generateVideoKML = ({ video, elementVideo }) => {
  const latlng0 = turf.point(videoOps.getLatLng0(video));
  const trackVideo = videoOps.getTrack(video);

  let templateIndex = 0;
  let kml =
    '<?xml version="1.0" encoding="UTF-8"?><kml xmlns="http://www.opengis.net/kml/2.2" xmlns:gx="http://www.google.com/kml/ext/2.2" xmlns:kml="http://www.opengis.net/kml/2.2" xmlns:atom="http://www.w3.org/2005/Atom"><Document>';

  if (elementVideo === 'Video') {
    kml += `<Data name="project"><value>${videoOps.getProject(video)}</value></Data>`;
    kml += `<Data name="name"><value>${videoOps.getName(video)}</value></Data>`;
    kml += `<Data name="url"><value><video src=${videoOps.getURL(video)}/></value></Data>`;
    kml += `<Data name="type"><value>${videoOps.getType(video)}</value></Data>`;
    kml += `<Data name="coordinatesDataType"><value>${videoOps.getCoordinatesDataType(
      video
    )}</value></Data>`;
    kml += `<Data name="timeGPSRecording"><value>${videoOps.getTimeGPS(video)}</value></Data>`;
    map(videoOps.getAnnotationTemplates(video), element => {
      templateIndex += 1;
      kml += `<Data name="template ${templateIndex}"><value>${templateOps.getName(
        element
      )}</value></Data>`;
    });
    kml += featurePoint2KML(latlng0);
  }
  if (!isEmpty(trackVideo)) {
    const controlPoints = videoOps.getControlPoints(video);
    kml += featureLinestring2KML(trackVideo);
    map(controlPoints.features, point => {
      kml += featurePoint2KML(point);
    });
  }
  kml += '</Document></kml>';

  return kml;
};

export default generateVideoKML;
